// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--1yE-i","siteTitle":"index-module--site-title--2JLHX","nav":"index-module--nav--2_J6E"};